module.exports = __webpack_public_path__ + "static/media/cdb18.65dcf86a.png";